import { useEffect, useMemo, useRef, useState } from "react";

import { Button } from "primereact/button";
import { Card } from "primereact/card";
import { Column } from "primereact/column";
import { confirmDialog } from "primereact/confirmdialog";
import { Checkbox } from 'primereact/checkbox';
import { DataTable } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { Toast } from "primereact/toast";

import Loading from "../components/Loading";
import Menu from "../components/Menu";

import api from "../services/api";

export default function Paradas() {
    const [paradas, setParadas] = useState([]);
    const [tipos, setTipos] = useState([]);

    const [computavel, setComputavel] = useState(0);
    const [id, setId] = useState(null);
    const [nome, setNome] = useState('');
    const [tipo, setTipo] = useState(null);

    const [display, setDisplay] = useState(false);
    const [filtroTipo, setFiltroTipo] = useState(null);
    const [filtroComputavel, setFiltroComputavel] = useState(null);
    const [filtroSituacao, setFiltroSituacao] = useState('todos');
    const [primeiroRegistro, setPrimeiroRegistro] = useState(0);
    const [loading, setLoading] = useState(false);
    const [mode, setMode] = useState(null);

    const toast = useRef(null);

    const handleSubmit = () => {
        if (nome === '' || tipo === null) {
            toast.current.show({
                summary: 'Aviso',
                severity: 'warn',
                detail: 'Por favor, preencha todos os campos antes de prosseguir'
            });
            return;
        }
        setLoading(true);
        api.post('cadastros/paradas/store', {
            "nome": nome,
            "tipo_id" : tipo,
            "computavel" : computavel
        }).then((response) => {
            let copy = [...paradas];
            copy.push(response.data.parada);
            setParadas(copy);

            hideDialog();
            setLoading(false);
            toast.current.show({
                summary: 'Concluído',
                severity: 'success',
                detail: response.data.message
            });
        }).catch((error) => {
            setLoading(false);
            toast.current.show({
                summary: 'Erro no Servidor',
                severity: 'error',
                detail: error.response.data.message
            });
        });
    }

    const handleUpdate = () => {
        if(nome === '' || tipo === null) {
            toast.current.show({
                summary: 'Aviso',
                severity: 'warn',
                detail: 'Por favor, preencha todos os campos antes de prosseguir'
            });
            return;
        }
        setLoading(true);
        api.post('cadastros/paradas/update', {
            "parada_id": id,
            "nome": nome,
            "tipo_id": tipo,
            "computavel": computavel
        }).then((response) => {
            setParadas(paradas.map((parada) => (
                parada.id === id ? response.data.parada : parada
            )));

            hideDialog();
            setLoading(false);
            toast.current.show({
                summary: 'Concluído',
                severity: 'success',
                detail: response.data.message
            });
        }).catch((error) => {
            setLoading(false);
            toast.current.show({
                summary: 'Erro no Servidor',
                severity: 'error',
                detail: error.response.data.message
            });
        });
    }

    const handleDelete = (rowData) => {
        confirmDialog({
            header: 'Confirmação',
            acceptLabel: 'Excluir',
            acceptClassName: 'p-button-danger',
            rejectLabel: 'Cancelar',
            rejectClassName: 'p-button-secondary',
            message: 'Você tem certeza que deseja excluir esse registro?',
            accept: () => {
                setLoading(true);
                api.post('cadastros/paradas/delete', {
                    'parada_id': rowData.id
                }).then((response) => {
                    setParadas(paradas.filter((parada) => parada.id !== rowData.id));

                    setLoading(false);
                    toast.current.show({
                        summary: 'Concluído',
                        severity: 'success',
                        detail: response.data.message
                    });
                }).catch((error) => {
                    setLoading(false);
                    toast.current.show({
                        summary: 'Concluído',
                        severity: 'success',
                        detail: error.response.data.message
                    });
                });
            }
        });
    }

    const handleAtivarDesativar = (rowData) => {
        confirmDialog({
            header: 'Confirmação',
            acceptLabel: `${rowData.ativo ? 'Desativar' : 'Ativar'}`, 
            acceptClassName: `${rowData.ativo ? 'p-button-danger' : 'p-button-success'}`, 
            rejectLabel: 'Cancelar',
            rejectClassName: 'p-button-secondary',
            message: `Você tem certeza que deseja ${rowData.ativo ? 'Desativar' : 'Ativar'} esse registro?`,
            accept: () => {
                setLoading(true);
                api.post('cadastros/paradas/ativar_desativar', {
                    'parada_id': rowData.id
                }).then((response) => {
                    setParadas(paradas.map((parada) => {
                        if (parada.id !== rowData.id) {
                            return parada;
                        }

                        return {
                            ...parada,
                            ativo: response.data.ativo !== undefined
                                ? response.data.ativo
                                : !parada.ativo
                        };
                    }));

                    setLoading(false);
                    toast.current.show({
                        summary: 'Concluído',
                        severity: 'success',
                        detail: response.data.message
                    });
                }).catch((error) => {
                    setLoading(false);
                    toast.current.show({
                        summary: 'Erro no Servidor',
                        severity: 'error',
                        detail: error.response?.data?.message || 'Ocorreu um erro.'
                    });
                });
            }
        });
    }

    const openDialog = (rowData, type = null) => {
        if(type === 'edit') {
            setComputavel(rowData.computavel);
            setId(rowData.id);
            setNome(rowData.nome);
            setTipo(rowData.tipo_id);
            setDisplay(true);
        }
    }

    const hideDialog = () => {
        setDisplay(false);
        setComputavel(0);
        setMode(null);
        setNome('');
        setTipo(null);
    }

    const opcoesTipo = useMemo(() => {
        const tiposUnicos = [...new Set(paradas.map((parada) => parada.tipo).filter(Boolean))];

        return tiposUnicos.sort().map((tipoParada) => ({
            label: tipoParada,
            value: tipoParada
        }));
    }, [paradas]);

    const opcoesComputavel = [
        { label: 'Computável', value: true },
        { label: 'Não Computável', value: false }
    ];

    const paradasFiltradas = useMemo(() => {
        return paradas.filter((parada) => {
            const atendeTipo = filtroTipo === null || filtroTipo === undefined || parada.tipo === filtroTipo;
            const atendeComputavel = filtroComputavel === null
                || filtroComputavel === undefined
                || parada.computavel === filtroComputavel;
            const atendeSituacao = filtroSituacao === 'todos'
                || (filtroSituacao === 'ativos' && parada.ativo === true)
                || (filtroSituacao === 'inativos' && parada.ativo === false);

            return atendeTipo && atendeComputavel && atendeSituacao;
        });
    }, [filtroComputavel, filtroSituacao, filtroTipo, paradas]);

    const configuracaoSituacao = {
        todos: {
            mensagem: 'Mostrando todos os registros',
            proximoFiltro: 'ativos',
            botao: 'Mostrar apenas ativos',
            icone: 'pi pi-check-circle'
        },
        ativos: {
            mensagem: 'Mostrando apenas ativos',
            proximoFiltro: 'inativos',
            botao: 'Mostrar apenas inativos',
            icone: 'pi pi-times-circle'
        },
        inativos: {
            mensagem: 'Mostrando apenas inativos',
            proximoFiltro: 'todos',
            botao: 'Mostrar todos',
            icone: 'pi pi-list'
        }
    }[filtroSituacao];

    const alterarFiltroSituacao = () => {
        setFiltroSituacao(configuracaoSituacao.proximoFiltro);
        setPrimeiroRegistro(0);
    }

    useEffect(() => {
        setLoading(true);
        api.get('cadastros/paradas').then((response) => {
            setParadas(response.data.paradas);
            setTipos(response.data.tipos);
            setLoading(false);
        }).catch((error) => {
            setLoading(false);
            toast.current.show({
                summary: 'Erro no Servidor',
                severity: 'error',
                detail: 'Não foi possível conectar ao servidor. Caso persista, entre em contato com o setor de TI.'
            });
        });
    }, []);

    if(loading) {
        return (
            <Loading />
        )
    }

    return (
        <div>
            <Menu />
            <Toast ref={toast} />

            <Dialog onHide={hideDialog} breakpoints={{ '960px': '90vw' }} style={{ minWidth: '30vw' }} visible={display} header={mode === "edit" ? "Editar" : "Cadastrar"} footer={() => (
                <div>
                    <Button className="p-button-secondary" label="Cancelar" onClick={hideDialog} />
                    <Button className="p-button-success" label="Salvar" loading={loading} onClick={mode === "edit" ? handleUpdate : handleSubmit} />
                </div>
            )}>
                <div className="p-fluid">
                    <div className="p-field">
                        <InputText
                            onChange={e => setNome(e.target.value)}
                            placeholder="Descrição da parada"
                            type="text"
                            value={nome}
                        />
                    </div>
                    <div className="p-field">
                        <Dropdown
                            onChange={e => setTipo(e.value)}
                            options={tipos}
                            value={tipo}
                        />
                    </div>
                    <div className="p-field">
                        <label htmlFor="computavel">Valor computável?</label><br></br>
                        <Checkbox
                            checked={computavel} 
                            falseValue={false}
                            onChange={e => setComputavel(e.checked)}
                            trueValue={true}
                        />
                    </div>
                </div>
            </Dialog>


            <Card header={() => (
                <div className="p-d-flex p-flex-row p-jc-between p-ai-start" style={{ width: '100%' }}>
                    <h1 className="p-m-3">Paradas</h1>
                    <Button className="p-button-primary p-mr-3 p-mt-3" icon="pi pi-plus" onClick={() => setDisplay(true)} />
                </div>
            )} className="p-m-3">
                <div className="p-d-flex p-jc-between p-ai-center p-mb-3" style={{ flexWrap: 'wrap', gap: '1rem' }}>
                    <strong>{configuracaoSituacao.mensagem}</strong>
                    <Button
                        className="p-button-outlined"
                        icon={configuracaoSituacao.icone}
                        label={configuracaoSituacao.botao}
                        onClick={alterarFiltroSituacao}
                    />
                </div>

                <DataTable
                    emptyMessage="Nenhum registro encontrado."
                    filterDisplay="row"
                    first={primeiroRegistro}
                    onPage={(event) => setPrimeiroRegistro(event.first)}
                    paginator
                    rows={8}
                    value={paradasFiltradas}
                >
                    <Column header="ID" field="id" />
                    <Column header="Nome" field="nome" sortable />
                    <Column
                        field="tipo"
                        filter
                        filterElement={() => (
                            <Dropdown
                                filter
                                onChange={(event) => {
                                    setFiltroTipo(event.value ?? null);
                                    setPrimeiroRegistro(0);
                                }}
                                options={opcoesTipo}
                                placeholder="Todos"
                                showClear
                                style={{ width: '100%' }}
                                value={filtroTipo}
                            />
                        )}
                        header="Tipo"
                        showFilterMenu={false}
                        sortable
                    />
                    <Column field="computavel" filter filterElement={() => (
                        <Dropdown
                            onChange={(event) => {
                                setFiltroComputavel(event.value ?? null);
                                setPrimeiroRegistro(0);
                            }}
                            options={opcoesComputavel}
                            placeholder="Todos"
                            showClear
                            style={{ width: '100%' }}
                            value={filtroComputavel}
                        />
                    )} header="Computável" showFilterMenu={false} sortable body={(rowData) => {
                        if(rowData.computavel === false) {
                            return 'Não Computável'
                        }  else {
                            return 'Computável'
                        }
                    }} />
                    <Column header="Criado em" field="data" />
                    <Column header="Situação" field="ativo" sortable body={(rowData) => {
                        if(rowData.ativo === true) {
                            return 'Ativo'
                        }  else {
                            return 'Inativo'
                        }
                    }} />
                    <Column header="Ações" body={(rowData) => (
                        <div>
                            <Button className="p-button-primary p-mr-1" icon="pi pi-pencil" onClick={() => {
                                setMode('edit');
                                openDialog(rowData, 'edit');
                            }} />
                            <Button className="p-button-danger p-ml-1" icon="pi pi-trash" onClick={() => handleDelete(rowData)} />
                            <Button className="p-button-warning p-ml-1" icon="pi pi-check" onClick={() => handleAtivarDesativar(rowData)} />
                        </div>
                    )} />
                </DataTable>
            </Card>
        </div>
    )
}
